export enum SharedContentCategory {
    SocialMedia = 'SocialMedia',
    Pricing = 'Pricing',
    NewsUpdates = 'NewsUpdates',
    HeroImages = 'HeroImages',
}
